import { render } from "./TwoFactorPromptModal.vue?vue&type=template&id=f3058e7e&scoped=true&ts=true"
import script from "./TwoFactorPromptModal.vue?vue&type=script&lang=ts"
export * from "./TwoFactorPromptModal.vue?vue&type=script&lang=ts"

import "./TwoFactorPromptModal.vue?vue&type=style&index=0&id=f3058e7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3058e7e"]])

export default __exports__